import './dashboard.css'



const Dashboard =()=>{

    return (
        <div className='dashboard-container'>

            <div className='field'>
                <div className='row' >
                    <div className='input-field col s12 m4'>
                        Academy Name
                    </div>
                    <div className='input-field col s12 m4'>

                      
                    <input
                        name="level"
                        type="text"
                        value="Everest Abacus Academy"
                    />
                    </div>

                </div>

                <div className='row' >
                    <div className='input-field col s12 m4'>
                        Email
                    </div>

                    <div className='input-field col s12 m4'>
                    
                       
                        <input
                        name="level"
                        type="text"
                        value=" kalpanaghadekar00@gmail.com"
                    />
                    
                    </div>
                  

                </div>
                <div className='row'>
                    <div className='input-field col s12 m4'>
                        Foundation Date
                    </div>
                    <div className='input-field col s12 m4'>
                    <input
                        name="level"
                        type="text"
                        value="25th March 2014"
                    />
                    </div>
                    
                </div>

                <div className='row' >
                    <div className='input-field col s12 m4'>
                       Address
                    </div>
                    <div className='input-field col s12 m4'>
                       
                        <textarea
                          style={{"height":'150px'}}
                          type="text"
                          value=" Everest Abacus Academy , Gunjan State Bank colony
                        Borude Mala, Balikashram road
                        Ahmednagar -404103"
                        >
                        </textarea>
                    </div>

                </div>

                <div className='row' >
                    <div className='input-field col s12 m4'>
                       HelpLine No
                    </div>
                    <div className='input-field col s12 m4'>
                       
                        <input
                          
                          type="number"
                          value ="8888781133"/>
                        
                        
                    </div>

                </div>

                <div className='row' >
                    <div className='input-field col s12 m4'>
                       Parcel
                    </div>
                    <div className='input-field col s12 m4'>
                       
                        <input
                          
                          type="number"
                          value ="9766638252"/>
                        
                        
                    </div>

                </div>


            </div>
           

        </div>
    )

}


export default Dashboard;